<template>
  <div v-title="$route.meta.title">
    <div class="page-heading" style="position:relative;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户标签管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <template slot="header">搜索</template>
      <el-form :model="search"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="标签ID" prop="tag_id">
            <el-input placeholder="请输入标签id"
                      v-model="search.tag_id"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="标签名" prop="keyword">
            <el-input placeholder="模糊搜索标签名称"
                      v-model="search.keyword"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="是否排他" prop="exclusive">
            <el-select v-model="search.exclusive"
                       placeholder="请选择是否排他"
                       class="width-max"
                       clearable>
              <el-option
                  v-for="item in [{label: '是', value: '1'}, {label: '否', value: '0'}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否标签组" prop="is_group">
            <el-select v-model="search.is_group"
                       placeholder="请选择是否标签组"
                       class="width-max"
                       clearable>
              <el-option
                v-for="item in [{label: '是', value: '1'}, {label: '否', value: '0'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/usertag/create'">
          <el-button type="success"
                     size="mini"
          > 添加标签
          </el-button>
        </router-link>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
      >

        <el-table-column prop="id"
                         label="标签ID">
        </el-table-column>
        <el-table-column prop="tagname"
                         label="标签名">
        </el-table-column>
        <el-table-column prop="exclusive"
                         label="是否排他">
          <template slot-scope="scope">
            {{scope.row.exclusive === '1' ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="is_group"
                         label="是否标签组">
          <template slot-scope="scope">
            {{scope.row.is_group === '1' ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="tagdesc"
                         label="标签描述">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <router-link :to="'/usertag/update/'+scope.row.id">
              <el-button type="primary"
                         size="mini">修改
              </el-button>
            </router-link>
            <el-button type="danger"
                       @click="onDelete(scope.row.id)"
                       size="mini">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
export default {
  mixins: [table],
  data () {
    return {
      search: {
        tag_id: null,
        keyword: null,
        exclusive: null,
        is_group: null,
      },
      table: [],
    }
  },
  methods: {
    getTableData (params) {
      return request.page('getUserTagTable', params)
    },
    onDelete (id) {
      this.$confirm('你确定要删除该用户标签吗？', '警告').then(_ => {
        request.common('deleteUsertag', {id}).then(_ => {
          this.$message.success('删除成功！')
          this.onSearch()
        })
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user-tag/pages/UserTagTable.vue